import { observer } from "mobx-react-lite";
import { states } from "../../pages/SourceType/SourceTypeRecord";
import { CoustomTableHeaderProps } from "../Table/CoustomTable";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../stores/store";
import { useState } from "react";
import { SourceTypeForm } from "../../models/SourceType";
import { SymbolTextBox } from "../Input/SymbolTextbox";
import TitlePath, { Page } from "../TitlePath/TitlePath";

interface Props {
    state: string
    buttonChoice: string

    lastPages?: Page[]
    title: string

    setState: (str: string) => void;
    setButtonChoice: (str: string) => void;
    options: Array<CoustomTableHeaderProps>;
    statesArray: states[];

}

export default observer(function CustomerHeader({ state, buttonChoice, title, lastPages, setState, setButtonChoice, options, statesArray }: Props) {

    const navigate = useNavigate();

    const [filterPlaceholder, ChangePlaceHolder] = useState("Filter Name");

    const filterProps = {
        placeholder: filterPlaceholder,//
        IconLeft: "/assets/button/filterProp/filterLeft.png",
        IconRight: "/assets/button/filterProp/filterRight.png",

    }



    return (
        <div className='  flex pl-3 my-4 flex-col gap-4  '>
            <TitlePath currentTitle={title} lastPages={lastPages} />

            <div className='flex justify-between'>
                <div className='flex' >
                    <SymbolTextBox
                        changePlaceholderValue={ChangePlaceHolder}
                        buttonChoice={buttonChoice}
                        defaultValue={state}
                        options={options}
                        IconLeft={filterProps.IconLeft}
                        IconRight={filterProps.IconRight}
                        placeholder={filterProps.placeholder}
                        onChange={(e) => setState(e.target.value)}
                        statesArray={statesArray}
                        setButtonChoice={setButtonChoice} />
                </div>
                <div className='flex'>

                </div>
            </div>
        </div>
    )
}
)